import { useState } from "react";
import { Link } from "react-router-dom";

const MainContent = () => {
  const data = [
    {
      id: 1,
      type: "Event",
      title: "Community Picnic",
      reason: "Inappropriate Content",
      reporter: "Sophia Clark",
      date: "2024-07-20",
      status: "Pending",
    },
    {
      id: 2,
      type: "Announcement",
      title: "New Policy Update",
      reason: "Spam",
      reporter: "Ethan Carter",
      date: "2024-07-18",
      status: "In Review",
    },
    {
      id: 3,
      type: "Message",
      title: "Private Conversation",
      reason: "Harassment",
      reporter: "Olivia Bennett",
      date: "2024-07-15",
      status: "Resolved",
    },
    {
      id: 4,
      type: "NGO Profile",
      title: "Charity Organization",
      reason: "Fraudulent Activity",
      reporter: "Liam Foster",
      date: "2024-07-12",
      status: "Action Taken",
    },
    {
      id: 5,
      type: "User Profile",
      title: "User: Alex Turner",
      reason: "Impersonation",
      reporter: "Ava Harper",
      date: "2024-07-10",
      status: "Pending",
    },
    {
      id: 6,
      type: "Event",
      title: "Tech Conference",
      reason: "Misleading Information",
      reporter: "Noah Parker",
      date: "2024-07-08",
      status: "In Review",
    },
    {
      id: 7,
      type: "Announcement",
      title: "Product Launch",
      reason: "Copyright Infringement",
      reporter: "Isabella Reed",
      date: "2024-07-05",
      status: "Resolved",
    },
    {
      id: 8,
      type: "Message",
      title: "Group Chat",
      reason: "Hate Speech",
      reporter: "Jackson Hayes",
      date: "2024-07-02",
      status: "Action Taken",
    },
    {
      id: 9,
      type: "NGO Profile",
      title: "Environmental Group",
      reason: "False Advertising",
      reporter: "Mia Coleman",
      date: "2024-06-29",
      status: "Pending",
    },
    {
      id: 10,
      type: "User Profile",
      title: "User: Chloe Evans",
      reason: "Privacy Violation",
      reporter: "Aiden Brooks",
      date: "2024-06-26",
      status: "In Review",
    },
  ];

  const [activeTab, setActiveTab] = useState("All");

  const getStatusColor = (status) => {
    switch (status) {
      case "Pending":
        return "bg-[#DFCD00] text-black";
      case "In Review":
        return "bg-[#F0F2F5] text-black";
      case "Resolved":
        return "bg-[#3FE36B] text-black";
      case "Action Taken":
        return "bg-[#F0F2F5] text-black";
      default:
        return "";
    }
  };

  const filteredData =
    activeTab === "All"
      ? data
      : data.filter((item) => item.status === activeTab);

  const tabs = ["All", "Pending", "In Review", "Resolved", "Action Taken"];

  return (
    <div className="w-[95%] mx-auto mt-8 mb-5">
      {/* Header */}
      <div className="mb-10">
        <h1 className="text-2xl md:text-3xl font-popinsBold">
          Flagged Content & Complaints
        </h1>
        <p className="text-sm font-popinsRegular text-[#61758A] mt-1">
          Review reported content and take necessary action.
        </p>
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap gap-4 md:gap-6 border-b border-gray-200 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`pb-2 text-sm font-popinsSemiBold transition-all duration-200 ${
              activeTab === tab
                ? "text-black border-b-2 border-[#61758A]"
                : "text-[#61758A] hover:text-black"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Table */}
      <div className="bg-white shadow rounded-xl overflow-hidden">
        <div className="overflow-x-auto sm:overflow-x-visible">
          <table className="min-w-full text-sm text-left">
            <thead className="text-xs uppercase border-b border-gray-300">
              <tr>
                <th className="px-4 py-3 font-popinsRegular">Content Type</th>
                <th className="px-4 py-3 font-popinsRegular">Title / ID</th>
                <th className="px-4 py-3 font-popinsRegular">Report Reason</th>
                <th className="px-4 py-3 font-popinsRegular">Reported By</th>
                <th className="px-4 py-3 font-popinsRegular">Date Reported</th>
                <th className="px-4 py-3 font-popinsRegular">Status</th>
                <th className="px-3 py-3 font-popinsRegular text-[#61758A]">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-300">
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-[#61758A] font-popinsRegular">
                      {item.type}
                    </td>
                    <td className="px-4 py-3 text-sm font-popinsRegular">
                      {item.title}
                    </td>
                    <td className="px-4 py-3 text-sm text-[#61758A] font-popinsRegular">
                      {item.reason}
                    </td>
                    <td className="px-4 py-3 text-sm text-[#61758A] font-popinsRegular">
                      {item.reporter}
                    </td>
                    <td className="px-4 py-3 text-sm text-[#61758A] font-popinsRegular">
                      {item.date}
                    </td>
                    <td className="px-4 py-3 text-sm text-[#61758A] font-popinsRegular">
                      <span
                        className={`inline-flex items-center justify-center w-28 px-4 py-2 rounded-md text-sm font-popinsMedium whitespace-nowrap ${getStatusColor(
                          item.status
                        )}`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-[#61758A] font-popinsSemiBold cursor-pointer">
                      <Link to={`/dashboard/content-review-detail/${item.id}`}>
                        View
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center py-6 text-[#61758A] font-popinsRegular"
                  >
                    No data available for this status.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
